import type { ReactNode } from 'react';

const REASON_LABEL: Record<string, string> = {
  forbidden: 'Bu işlem için yetkiniz yok.',
  auth_required: 'Devam etmek için tekrar giriş yapın.',
  network: 'Sunucuya bağlanılamadı. Bağlantınızı kontrol edip tekrar deneyin.',
  unknown: 'Bilinmeyen bir hata oluştu.',
  not_found: 'Aradığınız kayıt bulunamadı.',
  bad_request: 'İstek doğrulanamadı.',
  conflict: 'Bu işlem mevcut durumla çelişiyor.',
};

function describeReason(reason: string): { tr: string; raw: string } {
  if (reason.startsWith('capability_missing:')) {
    return { tr: 'Bu sayfa için gerekli yetki hesabınızda yok.', raw: reason };
  }
  if (reason.startsWith('network:')) return { tr: REASON_LABEL.network!, raw: reason };
  if (reason.startsWith('http_')) return { tr: 'Sunucu beklenmeyen bir yanıt döndü.', raw: reason };
  if (reason === 'empty_response_body') {
    return { tr: 'Sunucu boş yanıt döndü. Yenileyin veya API log\'larını kontrol edin.', raw: reason };
  }
  return { tr: REASON_LABEL[reason] ?? REASON_LABEL.unknown!, raw: reason };
}

export interface ErrorStateProps {
  readonly reason: string;
  readonly hint?: ReactNode;
  readonly onRetry?: () => void;
  readonly testId?: string;
}

export function ErrorState({ reason, hint, onRetry, testId }: ErrorStateProps): JSX.Element {
  const desc = describeReason(reason);
  return (
    <div className="error" role="alert" data-testid={testId}>
      <div>
        <strong>Bir sorun oluştu.</strong> {desc.tr}
      </div>
      {hint ? <div style={{ marginTop: 8 }}>{hint}</div> : null}
      <details className="disclosure" style={{ textAlign: 'left' }}>
        <summary>Teknik detayları göster</summary>
        <div className="muted" style={{ marginTop: 6, fontSize: 12 }}>
          <code>{desc.raw}</code>
        </div>
      </details>
      {onRetry ? (
        <div style={{ marginTop: 12 }}>
          <button className="btn btn-secondary btn-sm" onClick={onRetry}>Tekrar dene</button>
        </div>
      ) : null}
    </div>
  );
}
